export function handleSetTraining(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    newState.trainings[action.data.trainingNumber] = {
        id: action.data.trainingNumber,
        start: action.data.start,
        length: action.data.length,
        description: action.data.description
    };
    return newState;
}

export function handleAddTraining(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    let maxTrainingId = 0;
    Object.keys(newState.trainings).map(k => {
        const t = newState.trainings[k];
        if(t.id > maxTrainingId) maxTrainingId = t.id;
    });

    action.data['id'] = maxTrainingId * 1 + 1;
    newState.trainings[action.data['id']] = action.data;
    return newState;
}

export function handleUpdateTraining(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    let resultKey = -1;
    Object.keys(newState.trainings).map(k => {
        if(action.data.id == k) {
            resultKey = k;
        }
    });
    if(resultKey >= 0) {
        newState.trainings[resultKey] = {
            id: resultKey,
            start: action.data.startHour + ':' + action.data.startMinute,
            length: action.data.length,
            description: action.data.description
        };
    }
    return newState;
}

export function handleSetTrainingStart(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    newState.trainings[action.data.id].id = action.data.id;
    newState.trainings[action.data.id].start = action.data.start;
    return newState;
}

export function handleSetTrainingLength(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    newState.trainings[action.data.id].id = action.data.id;
    newState.trainings[action.data.id].length = action.data.length;
    return newState;
}

export function handleSetTrainingDescription(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    action.data.id = action.data.id * 1;
    newState.trainings[action.data.id].id = action.data.id;
    newState.trainings[action.data.id].description = action.data.description;
    return newState;
}

export function handleRemoveTraining(state, action) {
    const newState = Object.assign({}, state);
    newState.menuChanged = true;

    let resultTrainings = {};
    Object.keys(newState.trainings).map(k => {
        if(k != action.data) {
            resultTrainings[k] = newState.trainings[k];
        }
    });
    newState.trainings = resultTrainings;
    return newState;
}
